import React, { useState, useEffect, useRef } from "react";

import { useDispatch } from "react-redux";

import { Button, DataGrid, Form } from "devextreme-react";
import { GroupItem, Label, SimpleItem } from "devextreme-react/form";
import DataSource from "devextreme/data/data_source";
import { fieldList } from "./data";

import axios from "axios";
import {
  Column,
  Editing,
  Lookup,
  RowDragging,
} from "devextreme-react/data-grid";
import { updateCommonSeriesSettings, updateSeries } from "./Redux/seriesSlice";
import ButtonOKCancel from "./ButtonOKCancel";

export default function SeriesContainer(props) {
  const { seriesPopupRef } = props;

  const [argumentField, setArgumentField] = useState(null);
  const [commonSeries, setCommonSeries] = useState([]);
  const [valueField, setValueField] = useState(null);
  const [series, setSeries] = useState([]);
  const [value, setValue] = useState([]);

  const formRef = useRef(null);
  const seriesDataGridRef = useRef(null);

  const dispatch = useDispatch();

  useEffect(() => {
    if (argumentField) {
      axios
        .get(
          `${process.env.REACT_APP_BECCO_API_URL}/api/mdcinClincTestInfoService01/VALUE`,
          {
            params: {
              field: argumentField,
            },
          }
        )
        .then((result) => {
          setCommonSeries(result.data);
        });
    }
  }, [argumentField]);

  useEffect(() => {
    if (valueField) {
      axios
        .get(
          `${process.env.REACT_APP_BECCO_API_URL}/api/mdcinClincTestInfoService01/VALUE`,
          {
            params: {
              field: valueField,
            },
          }
        )
        .then((result) => {
          setValue(result.data);
        });
    }
  }, [valueField]);

  const argumentFieldEditorOptions = {
    // items: Object.keys(dataSource[0]),
    // dataSource: fieldList,
    dataSource: new DataSource({
      store: {
        type: "array",
        data: fieldList,
        key: "id",
      },
      sort: [
        {
          selector: "name",
          desc: false,
        },
      ],
    }),
    valueExpr: "id",
    displayExpr: "name",
    showClearButton: true,
    onValueChanged: (e) => {
      setArgumentField(e.value);
    },
  };

  const commonSeriesEditorOptions = {
    dataSource: commonSeries,
    searchEnabled: true,
  };

  const fieldEditorOptions = {
    dataSource: new DataSource({
      store: {
        type: "array",
        data: fieldList,
        key: "id",
      },
      sort: [
        {
          selector: "name",
          desc: false,
        },
      ],
    }),
    valueExpr: "id",
    displayExpr: "name",
    showClearButton: true,
    onValueChanged: (e) => {
      setValueField(e.value);
    },
  };

  const onReorder = (e) => {
    const visibleRows = e.component.getVisibleRows();
    const newSeries = [...series];
    const toIndex = newSeries.indexOf(visibleRows[e.toIndex].data);
    const fromIndex = newSeries.indexOf(e.itemData);

    newSeries.splice(fromIndex, 1);
    newSeries.splice(toIndex, 0, e.itemData);

    setSeries(newSeries);
  };

  const onOkClick = (e) => {
    dispatch(
      updateCommonSeriesSettings(formRef.current.instance.option("formData"))
    );
    dispatch(
      updateSeries(seriesDataGridRef.current.instance.getDataSource().items())
    );

    seriesPopupRef.current.instance.hide();
  };

  const onCancelClick = (e) => {
    seriesPopupRef.current.instance.hide();
  };

  return (
    <React.Fragment>
      <Form ref={formRef}>
        <GroupItem caption="가로 (항목) 축 레이블">
          <SimpleItem
            dataField="argumentField"
            editorType="dxSelectBox"
            editorOptions={argumentFieldEditorOptions}
          >
            <Label text="항목" />
          </SimpleItem>
          <SimpleItem
            dataField="commonSeries"
            editorType="dxTagBox"
            editorOptions={commonSeriesEditorOptions}
          >
            <Label text="값" />
          </SimpleItem>
        </GroupItem>
        <GroupItem caption="범례 항목 (계열)">
          <SimpleItem
            dataField="valueField"
            editorType="dxSelectBox"
            editorOptions={fieldEditorOptions}
          >
            <Label text="항목" />
          </SimpleItem>
          <GroupItem catpion="계열 편집">
            <DataGrid
              ref={seriesDataGridRef}
              dataSource={series}
              keyExpr="id"
              showBorders={true}
            >
              <RowDragging
                allowReordering={true}
                onReorder={onReorder}
                showDragIcons={true}
              />
              <Editing
                mode="form"
                allowAdding={true}
                allowUpdating={true}
                allowDeleting={true}
              />
              <Column dataField="value" caption="계열 값">
                <Lookup dataSource={value} />
              </Column>
              <Column dataField="name" caption="계열 이름" />
            </DataGrid>
          </GroupItem>
        </GroupItem>
      </Form>
      {/* <Button
        width={120}
        text="취소"
        type="normal"
        stylingMode="outlined"
        onClick={onCancelClick}
      />
      <Button
        width={120}
        text="확인"
        type="success"
        stylingMode="outlined"
        onClick={onOkClick}
      /> */}
      <ButtonOKCancel onCancelClick={onCancelClick} onOkClick={onOkClick} />
    </React.Fragment>
  );
}
